import { connect } from 'react-redux';
import RightNav from '../components/RightNav';

export default connect(

  state => {
    const rightNavLabel = state.externalisedStrings['common.header.contactUsRaven'];
    const rightNavLink = state.externalisedStrings['common.header.contactUsLinkRaven'];

    return ({
      rightNavLabel,
      rightNavLink,
    });
  }
)(RightNav);
